<template>
  <div class="container_VideosPlayForm" v-if="!isConfirm">
    <VideosMaximizedForm
      :show="verModal"
      @close="verModal = false"
      :nombre-video="valueLocal.nombreVideo ? valueLocal.nombreVideo : ''"
      :url-video="valueLocal.urlVideo"
      :descripcion-confidencial="$t('label.videos.prosegur.confidencial')"
      :controls="controls"
    />
    <PColapsable
      :value="isColapsableDatosNovedad"
      @change="validarColapsable($event, 'datos-novedad')"
    >
      <template #title> {{ $t("label.datosNovedad") }}</template>
      <PDataLine :value="valuesVideo" :fields="fieldsVideo" justifyContent="flex-start" />
      <div class="d-flex justify-content-center" v-if="!aceptaDatosReadonly">
        <PFormSwitch
          v-model="visionadoLocal.aceptaDatos"
          :label="$t('label.aceptarDatos')"
          :readonly="aceptaDatosReadonly"
          @change="action('aceptarDatos')"
        />
      </div>
      <div v-else class="aceptaDatosReadonly_VideosPlayForm">
        <PDataLine
          justifyContent="space-around"
          :widthContent="true"
          :classContainer="visionadoLocal.aceptaDatos ? 'ok' : 'ko'"
          :value="{ aceptaDatos: visionadoLocal.aceptaDatos }"
          :fields="{
            aceptaDatos: {
              width: '100%',
              emptyShow: true,
              view: 'validate',
              trueText: $t('label.datosAceptados'),
              falseText: $t('label.datosRechazados'),
              trueVariant: 'ok fieldTextoDataLine',
              falseVariant: 'ko fieldTextoDataLine',
            },
          }"
        />
      </div>
    </PColapsable>

    <PForm
      v-model="validado"
      @accept="action('aceptar')"
      :textAction="$t('action.aceptar')"
      :showCancel="false"
      buttonsAlign="right"
      class="aceptaDatos_VideosPlayForm"
    >
      <PColapsable
        :value="isColapsableVideo"
        v-if="showDetailsVideo"
        @change="validarColapsable($event, 'video')"
      >
        <template #title> {{ $t("label.video") }} </template>
        <div class="textMessage_VideosPlayForm" v-if="showDetailsVideo">
          <span>
            {{ this.$t("label.videos.prosegur.confidencial") }}
          </span>
        </div>
        <div
          class="containerVideo_VideosPlayForm"
          v-if="
            aceptaDatosReadonly &&
            visionadoLocal.aceptaDatos &&
            valueLocal.urlVideo.indexOf('/') > 0
          "
        >
          <video
            :ref="valueLocal.nombreVideo"
            autoplay
            controls
            disableRemotePlayback
            :controlslist="controls"
            width="100%"
          >
            <source :src="valueLocal.urlVideo" type="video/mp4" />
            <track kind="subtitles" src="" />
          </video>
        </div>
        <div class="buttons_VideosMaximizar">
          <PButton @click="verVideoMaximizado" variant="secondary">
            <b-icon-fullscreen class="align-middle mr-1" />
            {{ $t("label.maximizar") }}</PButton
          >
        </div>
        <div class="text-center" v-if="aceptaDatosReadonly && visionadoLocal.aceptaDatos">
          <PFormRadioButton
            v-if="!aceptaNovedadReadonly"
            v-model="visionadoLocal.aceptaNovedad"
            :label="$t('label.aceptarNovedades')"
          />
        </div>
        <div
          v-if="aceptaNovedadReadonly && visionadoLocal.aceptaDatos"
          class="aceptaDatosReadonly_VideosPlayForm"
        >
          <PDataLine
            justifyContent="space-around"
            :widthContent="true"
            :classContainer="visionadoLocal.aceptaNovedad ? 'ok' : 'ko'"
            :value="{
              aceptaNovedad: visionadoLocal.aceptaNovedad,
            }"
            :fields="{
              aceptaNovedad: {
                width: '100%',
                emptyShow: true,
                view: 'validate',
                trueText: $t('label.novedadAceptada'),
                falseText: $t('label.novedadRechazada'),
                trueVariant: 'ok fieldTextoDataLine',
                falseVariant: 'ko fieldTextoDataLine',
              },
            }"
          />
        </div>
      </PColapsable>
      <PRow>
        <PCol md="12">
          <PFormInputText
            id="input_observaciones"
            v-if="!aceptaNovedadReadonly"
            v-model="visionadoLocal.observaciones"
            :label="$t('label.observaciones')"
            type="textarea"
            :rows="5"
            :rules="
              visionadoLocal.aceptaDatos && !visionadoLocal.aceptaNovedad
                ? 'required|max:2000'
                : 'max:2000'
            "
          />
          <PDataLine
            v-else
            :showBorder="false"
            :value="{ observaciones: visionadoLocal.observaciones }"
            :fields="{
              observaciones: {
                title: this.$t('label.observaciones'),
                width: '100%',
                emptyShow: true,
              },
            }"
          />
        </PCol>
      </PRow>
    </PForm>
  </div>
  <div v-else>
    <PConfirm
      :textButtonAccept="$t('action.aceptar')"
      @accept="action('aceptarConfirm')"
      @cancel="isConfirm = false"
    >
      <template #title>
        {{ $t("title.videos.noAcepta") }}
      </template>
      <template #description>
        {{ $t("title.videos.descripcionConfirm") }}
      </template>
    </PConfirm>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import VueFilters from "@/vue-filters";
import VideosMaximizedForm from "@/pages/videos/components/VideosMaximizedForm.vue";
import { IVideo, UsuarioXVideo, Video } from "@/entities";

@Component({
  mixins: [VueFilters],
  components: {
    VideosMaximizedForm,
  },
})
export class VideosPlayForm extends Vue {
  @Prop({ required: true }) value!: IVideo;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.value) {
      this.valueLocal = JSON.parse(JSON.stringify(this.value));
      if (this.valueLocal.listUsuarios?.length) {
        this.visionadoLocal = JSON.parse(JSON.stringify(this.valueLocal.listUsuarios[0]));
        this.aceptaDatosReadonly = true;
        if (this.valueLocal.listUsuarios[0].aceptaNovedad === null) {
          this.visionadoLocal.aceptaNovedad = false;
          this.aceptaNovedadReadonly = false;
        } else {
          this.aceptaNovedadReadonly = true;
        }
      } else {
        this.$bvToast.toast(this.$t("label.videos.prosegur.confidencial"), {
          title: this.$t("label.confidencial"),
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top25-center",
          noAutoHide: true,
        });
        this.visionadoLocal = new UsuarioXVideo();
        this.visionadoLocal.fkVideo = this.valueLocal.id;
        this.aceptaDatosReadonly = false;
        this.aceptaNovedadReadonly = false;
      }
    }
  }

  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getLocale") locale!: Locale;
  validado = false;
  isConfirm = false;
  aceptaDatosReadonly = false;
  aceptaNovedadReadonly = false;
  valueLocal: IVideo = new Video();
  visionadoLocal = new UsuarioXVideo();
  isColapsableDatosNovedad = false;
  isColapsableVideo = false;
  verModal = false;

  validarColapsable(value: boolean, componentName: string): void {
    if ("datos-novedad" === componentName) {
      this.isColapsableDatosNovedad = value;
      this.isColapsableVideo = this.isColapsableVideo ? !this.isColapsableDatosNovedad : false;
    } else if ("video" === componentName) {
      this.isColapsableVideo = value;
      this.isColapsableDatosNovedad = this.isColapsableDatosNovedad
        ? !this.isColapsableVideo
        : false;
    }
  }

  verVideoMaximizado(): void {
    this.verModal = true;
  }

  get showDetailsVideo(): boolean {
    return (
      this.aceptaDatosReadonly &&
      this.visionadoLocal.aceptaDatos &&
      this.valueLocal.urlVideo.indexOf("/") > 0
    );
  }

  get controls(): string {
    if (this.valueLocal.cliente.pais.descargarVideos) {
      return "nofullscreen noremoteplayback";
    }
    return "nodownload nofullscreen noremoteplayback";
  }

  get valuesVideo(): any {
    return {
      fecha: this.filterDateTime(this.valueLocal.fecha),
      cliente: this.valueLocal.cliente.desCliente,
      tipoNovedad: this.valueLocal.tipoNovedad
        ? this.$t(`label.tipoNovedad.${this.valueLocal.tipoNovedad.codParametro?.toLowerCase()}`)
        : undefined,
      importe: this.valueLocal.importe ? this.filterNumber(this.valueLocal.importe) : undefined,
      ciudad: this.valueLocal.ciudad,
      sucursal: this.valueLocal.sucursal,
      puntoServicio: this.valueLocal.puntoServicio?.desPuntoservicio,
      delegacion: this.valueLocal.delegacion.desDelegacion,
      fechaNovedad: this.filterDateTime(this.valueLocal.fechaNovedad),
      nombreRevisores: this.valueLocal.nombreRevisores,
      cedulasCiudadania: this.valueLocal.cedulasCiudadania,
      observaciones: this.valueLocal.observaciones,
    };
  }

  fieldsVideo = {
    fecha: { title: this.$t("label.fecha"), width: "25%", emptyShow: false },
    cliente: { title: this.$t("label.cliente"), width: "75%", emptyShow: false },
    fechaNovedad: { title: this.$t("label.fechaNovedad"), width: "25%", emptyShow: false },
    tipoNovedad: { title: this.$t("label.tipoNovedad"), width: "25%", emptyShow: false },
    importe: { title: this.$t("label.importe"), width: "25%", emptyShow: false },
    ciudad: { title: this.$t("label.ciudad"), width: "25%", emptyShow: false },
    sucursal: { title: this.$t("label.sucursal"), width: "50%", emptyShow: false },
    delegacion: { title: this.$t("label.delegacion"), width: "25%", emptyShow: false },
    puntoServicio: { title: this.$t("label.puntoServicio"), width: "25%", emptyShow: false },
    nombreRevisores: { title: this.$t("label.nombreRevisor"), width: "25%", emptyShow: false },
    cedulasCiudadania: {
      title: this.$t("label.cedulasCiudadania"),
      width: "75%",
      emptyShow: false,
    },
    observaciones: { title: this.$t("label.observaciones"), width: "100%", emptyShow: false },
  };

  action(action: string): void {
    if (!this.valueLocal.listUsuarios?.length) {
      this.valueLocal.listUsuarios?.push(this.visionadoLocal);
    } else {
      this.valueLocal.listUsuarios[0] = this.visionadoLocal;
    }

    if (action === "aceptarDatos") {
      this.aceptaDatosReadonly = true;
      this.$emit("action", { data: this.valueLocal, action: action });
    } else if (action === "aceptar") {
      if (!this.aceptaDatosReadonly) {
        this.isConfirm = true;
      } else {
        this.$emit("action", { data: this.valueLocal, action: action });
      }
    } else if (action === "aceptarConfirm") {
      this.$emit("action", { data: this.valueLocal, action: "aceptar" });
      this.aceptaDatosReadonly = true;
      this.isConfirm = false;
    }
  }
}

export default VideosPlayForm;
</script>
<style lang="scss" scoped>
.container_VideosPlayForm {
  padding: 0 1rem;
}
.aceptaDatosReadonly_VideosPlayForm {
  display: flex;
  justify-content: space-around;
}
.aceptaDatos_VideosPlayForm {
  &::v-deep .itemsButtons_PForm {
    margin-right: 0;
    .primary_PButton {
      margin-right: 0;
    }
  }
}
.containerVideo_VideosPlayForm {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
.textMessage_VideosPlayForm {
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 0.5rem;
  font-size: 19px;
}
.buttons_VideosPlayForm {
  display: flex;
  justify-content: flex-end;
}
.buttons_VideosMaximizar {
  display: flex;
  justify-content: flex-end;
}
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
</style>
